// GENERATED by scripts/fetch-low-price-countries.mjs on 2026-10-17. Do not edit by hand.
// World Bank low income (LIC) + lower-middle income (LMC) economies: the countries that keep the 8-page book
// and the $1.99 PDF (owner decision 2026-10-16). Regenerate yearly after the July reclassification.
export const LOW_PRICE_COUNTRIES_SOURCE = { url: 'https://api.worldbank.org/v2/country?format=json&per_page=400', fetched: '2026-10-17', fiscalYear: 'current at fetch time' } as const;

export const LOW_PRICE_COUNTRIES: ReadonlySet<string> = new Set([
  'AF', // Afghanistan
  'AO', // Angola
  'BD', // Bangladesh
  'BF', // Burkina Faso
  'BI', // Burundi
  'BJ', // Benin
  'BO', // Bolivia
  'BT', // Bhutan
  'CD', // Congo, Dem. Rep.
  'CF', // Central African Republic
  'CG', // Congo, Rep.
  'CI', // Cote dIvoire
  'CM', // Cameroon
  'DJ', // Djibouti
  'EG', // Egypt, Arab Rep.
  'ER', // Eritrea
  'ET', // Ethiopia
  'GH', // Ghana
  'GM', // Gambia, The
  'GN', // Guinea
  'GW', // Guinea-Bissau
  'HN', // Honduras
  'HT', // Haiti
  'IN', // India
  'KE', // Kenya
  'KG', // Kyrgyz Republic
  'KH', // Cambodia
  'KI', // Kiribati
  'KM', // Comoros
  'KP', // Korea, Dem. Peoples Rep.
  'LA', // Lao PDR
  'LB', // Lebanon
  'LR', // Liberia
  'LS', // Lesotho
  'MA', // Morocco
  'MG', // Madagascar
  'ML', // Mali
  'MM', // Myanmar
  'MR', // Mauritania
  'MW', // Malawi
  'MZ', // Mozambique
  'NA', // Namibia
  'NE', // Niger
  'NG', // Nigeria
  'NI', // Nicaragua
  'NP', // Nepal
  'PG', // Papua New Guinea
  'PK', // Pakistan
  'PS', // West Bank and Gaza
  'RW', // Rwanda
  'SB', // Solomon Islands
  'SD', // Sudan
  'SL', // Sierra Leone
  'SN', // Senegal
  'SO', // Somalia, Fed. Rep.
  'SS', // South Sudan
  'ST', // Sao Tome and Principe
  'SY', // Syrian Arab Republic
  'SZ', // Eswatini
  'TD', // Chad
  'TG', // Togo
  'TJ', // Tajikistan
  'TL', // Timor-Leste
  'TN', // Tunisia
  'TZ', // Tanzania
  'UG', // Uganda
  'UZ', // Uzbekistan
  'VE', // Venezuela, RB
  'VU', // Vanuatu
  'YE', // Yemen, Rep.
  'ZM', // Zambia
  'ZW', // Zimbabwe
]);

/** True for an ISO 3166-1 alpha-2 code in LOW_PRICE_COUNTRIES. Unknown, empty, XX and T1 are false. */
export function isLowPriceCountry(code: string | null | undefined): boolean {
  return !!code && LOW_PRICE_COUNTRIES.has(code.trim().toUpperCase());
}
